$(document).ready(function () {
  const $slider = $(".slider-wrapper-content");
  const $prevButton = $(".slick-prev");
  const $nextButton = $(".slick-next");
  const $slides = $slider.children();
  const slideCount = $slides.length;
  let currentIndex = 0;

  function updateSlidePosition() {
    $slider.css("transform", `translateX(-${currentIndex * 100}%)`);
    checkButtonState();
  }

  function checkButtonState() {
    $prevButton.toggleClass("at-start", currentIndex === 0);
    $nextButton.toggleClass("at-end", currentIndex >= slideCount - 1);
  }

  $prevButton.on("click", function () {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlidePosition();
    }
  });

  $nextButton.on("click", function () {
    if (currentIndex < slideCount - 1) {
      currentIndex++;
      updateSlidePosition();
    }
  });

  // Initialize slider
  updateSlidePosition();

  // Handle click events for slides (example with video and image)
  $slides.on("click", function () {
    const $slide = $(this);
    const $video = $slide.find("video");
    const $img = $slide.find(".quick-setup-content-item-img");
    if ($video.length) {
      $img.hide();
      $video.show();
      $video.get(0).play();
    }
  });
});
